import React from 'react'
import SbEditable from 'storyblok-react'
import RichText from 'src/utils/RichText'
import Heading from 'src/components/Heading'
import Wave from 'src/utils/Wave'
import FluidImage from 'src/utils/FluidImage'
import { Link } from 'gatsby'
import resolveLink from 'src/utils/resolveLink'

const Children = (props) => {
    return (
        <>
            <FluidImage image={props.image} className={`mb-4 relative rounded-md ${props.target?.cached_url && 'group-hover:opacity-70 group-hover:-translate-y-2 duration-300'}`}/>
            <Heading size="h6" className={`text-blue !mb-1 ${props.target?.cached_url && 'group-hover:text-teal duration-300'}`}>{props.title}</Heading>
            <p className="text-darkblue-400 tracking-[-0.01em] lg:text-base text-sm">{props.description}</p>
        </>
    )
}

const ThreeColumnCardsCustom = ({ blok }) => {
    return (
        <SbEditable content={blok} key={blok._uid}>
            <div>
                <Wave size="small" className={`fill-lightgrey`} flip/>
                <div className="bg-lightgrey">
                    <div className="relative max-w-7xl mx-auto px-6 lg:py-24 py-12 2xl:max-w-screen-2xl">
                        <div className="flex lg:flex-row flex-col lg:justify-between lg:items-end gap-y-4">
                            <div>
                                <Heading size="h3" className="">{blok.title}</Heading>
                                <div className="prose lg:text-base text-sm max-w-2xl">
                                    <RichText>{blok.description}</RichText>
                                </div>
                            </div>
                        </div>
                        <div className="lg:pt-14 pt-10 grid gap-8 md:grid-cols-3">
                            {blok.items.map((item) => (
                                item.target?.cached_url ?
                                <Link to={resolveLink(item.target.cached_url)} className="group">
                                    <Children {...item}/>
                                </Link>
                                :
                                <div className="group">
                                    <Children {...item}/>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </SbEditable>
    )
}

export default ThreeColumnCardsCustom